class CylindoWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const closeButton = this.querySelector("[data-close]");
    closeButton.addEventListener("click", () => {
      closeButton.dispatchEvent(
        new CustomEvent("cylindo-trigger", {
          bubbles: true,
          detail: { action: null },
        }),
      );
    });

    this.handleTrigger = (e) => {
      if (!this.initialized) {
        this._init();
      }

      const viewer = this.querySelector("cylindo-viewer");

      const { action } = e.detail;

      this.toggleAttribute("active", action);

      // this.setAttribute("action", action);

      // Show viewer
      viewer.ar = action === "view-in-your-space";

      const indexMap = {
        "view-360": 0,
        dimensions: 1,
      };

      if (action in indexMap) {
        viewer.item = { viewerItemIndex: indexMap[action] };
      }
    };

    document.addEventListener("cylindo-trigger", this.handleTrigger);
  }

  disconnectedCallback() {
    document.removeEventListener("cylindo-trigger", this.handleTrigger);
  }

  _init() {
    const template = this.querySelector("template");
    this.append(template.content.children[0]);
    this.initialized = true;
  }
}

if (!customElements.get("cylindo-wrapper")) {
  customElements.define("cylindo-wrapper", CylindoWrapper);
}
